"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bson_1 = require("bson");
var buffer_1 = require("buffer");
var crypto = require("crypto");
var blobparser_1 = require("./parsers/blobparser");
var util_1 = require("./util");
function decryptFile(data, name, key) {
    return blobparser_1.default.parse(data, name, key);
}
exports.decryptFile = decryptFile;
function encryptFile(paste, passwordsize) {
    if (passwordsize === void 0) { passwordsize = 32; }
    var data = paste.serialize();
    var password = util_1.randomPassword(passwordsize);
    var payload = {
        data: null,
        iterations: 10000,
        salt: crypto.randomBytes(8),
        version: 2,
    };
    var key = crypto.pbkdf2Sync(password, payload.salt, payload.iterations, 5, 'sha512');
    var cipher = crypto.createCipher('aes256', key);
    var encrypted = buffer_1.Buffer.concat([cipher.update(data), cipher.final()]);
    payload.data = encrypted;
    var bson = new bson_1.BSON();
    return {
        data: bson.serialize(payload),
        key: password,
    };
}
exports.encryptFile = encryptFile;
